import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8UserURL } from 'services/production/utils/getM8URL';
import { M8DemoStackDTO } from 'services/production/types';

export const getDemoStackInfo = async (): Promise<null | M8DemoStackDTO> => {
  const response = await customFetch(getM8UserURL('getDemoStackInfo'));

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  try {
    const data = await response.json();

    return data;
  } catch {
    return null;
  }
};
